import React, { FunctionComponent } from "react"
import { Controller } from "react-hook-form"
import { SPACE_TAG_STYLE } from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import AsyncSelectInput from "../../../components/Form/Select/AsyncSelect"
import { iExhibition } from "../../../definitions/Exhibition"
import { iResponse } from "../../../definitions/interfaces"
import { iSpace } from "../../../definitions/Space"
import { get } from "../../../store/data/actions"

interface iProps {
  space?: iSpace
}

const SpaceOverview: FunctionComponent<iProps> = ({ space }) => {
  const loadSpaces = async (input: string) => {
    const res = await get<iResponse<iExhibition>>({
      link: "/v2/exhibition-list",
      query: { title: input, gallerySpaceId: space?._id },
    })

    return res.data
  }

  return (
    <div className="scrollable">
      <FormInput name="title" label="Title" />
      <FormInput name="subtitle" label="Subtitle" />
      <Controller as={Textarea} name="description" label="Short description" />
      <AsyncCreatableTag group={SPACE_TAG_STYLE} name="tags" label="Tags" />
      <FormInput name="video" label="Vimeo ID" />
      <FormInput name="featured" label="Featured" type="checkbox" />
      <Controller
        name="walkthrough"
        render={({ value, onChange }) => (
          <AsyncSelectInput
            value={value}
            onChange={onChange}
            name="walkthrough"
            loadOptions={loadSpaces}
            defaultOptions
            label="Walkthrough"
          />
        )}
      />
    </div>
  )
}

export default SpaceOverview
